module.exports = __webpack_public_path__ + "static/media/Special-offers.ff08def7.svg";